import { useCallback, useState } from 'react';

export default function useRefetch() {
  const [refetchFlag, setRefetchFlag] = useState(false);

  const refetch = useCallback(() => setRefetchFlag((old) => !old), []);

  return { refetchFlag, refetch };
}
